import { useContext, useEffect } from 'react';
import { AuthContext } from './AuthRoute';

const LoginRedirect = () => {
    const {
        getTokenSession,
    } = useContext(AuthContext);

    useEffect(() => {
        // reuse an existing Cognito session if present, otherwise getTokenSession routes to login
        getTokenSession()
            .then((res) => {
                const landingPage = res['id_token']['custom:LandingPage'];
                window.location.href = landingPage
                    ? `${window.location.origin}${landingPage}`
                    : `${window.location.origin}/MainLanding`;
            })
            .catch(() => {
                // no session -- getTokenSession has already triggered the login redirect
            });
    }, []);

    return (
        <></>
    );

}

export default LoginRedirect;
